'use client';
import { Button, Empty, Spin } from 'antd';
import styles from './tickets.module.scss';
import React, { useEffect, useState } from 'react';
import { PaginationType, ResponseType, TicketStatusEnum, TicketType } from 'types';
import TicketCardComp from './ticketCard/ticketCard.index';
import { RestAPI, useBP } from 'scripts';
import TicketMessageDetailComp from './ticketMessageDetail/ticketMessageDetail.index';
import { API, PATH } from 'data';
import { Link } from 'react-router-dom';
import { MobileHeaderComp } from 'components';

function TicketComp() {
    const [activeTicket, setActiveTicket] = useState<TicketType>();
    const [chatListData, setTicketListData] = useState<ResponseType<PaginationType<TicketType>>>();
    const bp = useBP()?.MD_LTE;

    useEffect(() => {
        setTicketListData(undefined);
        RestAPI.get<PaginationType<TicketType>>(API.ticket.index, {
            page: 1,
            page_size: 100,
        })
            .then(setTicketListData)
            .catch(setTicketListData);
    }, []);

    return (
        <>
            <MobileHeaderComp title="پشتیبانی تیک سبز" />
            <div className={`${styles['chat-layout']} d-flex`}>
                <div className={`${styles['chat-list']} flex-1 ${activeTicket && bp ? 'd-none' : ''}`}>
                    <div className="w-100 ph-3 mb-2 mt-3">
                        <Link to={PATH.panel.tickets.new()}>
                            <Button type="dashed" className="w-100">
                                ثبت تیکت پشتیبانی
                            </Button>
                        </Link>
                    </div>
                    <div className={`${styles['message-list']}`}>
                        {!chatListData ? (
                            <div className={`w-100 pv-9 center-content flex-1`}>
                                <Spin />
                            </div>
                        ) : (
                            <>
                                {chatListData?.data.data.length ? (
                                    chatListData.data.data.map((item, index) => (
                                        <TicketCardComp
                                            key={index}
                                            data={item}
                                            className="mb-2"
                                            onClick={() => {
                                                setActiveTicket(item);
                                            }}
                                        />
                                    ))
                                ) : (
                                    <Empty
                                        className="w-100 center-content-i mt-3-i"
                                        description={
                                            <p className="t-p2 t-l-gray1 t-400 text-center">تا کنون چتی نداشته اید</p>
                                        }
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div className={`${styles['chat-detail']} flex-1 ${!activeTicket && bp ? 'd-none' : ''}`}>
                    {activeTicket ? (
                        <TicketMessageDetailComp
                            data={activeTicket}
                            onSent={() => {
                                if (chatListData) {
                                    const newList = { ...chatListData };
                                    const index = newList.data?.data.findIndex((i) => i.id === activeTicket.id);
                                    if (newList.data?.data.length && index !== undefined && index >= 0) {
                                        newList.data.data[index] = {
                                            ...newList.data.data[index],
                                            status: TicketStatusEnum.pending,
                                        };
                                    }
                                    setTicketListData(newList);
                                }
                            }}
                        />
                    ) : (
                        <Empty
                            className="w-100 center-content-i mt-3-i mh-0"
                            description={
                                <p className="t-p2 t-l-gray1 t-400 text-center">لطفا یک مورد برای چت انتخاب نمایید</p>
                            }
                        />
                    )}
                </div>
            </div>
        </>
    );
}

export default TicketComp;
